<script lang="ts" setup>
import { computed, navigateTo, onMounted, ref, useRoute } from '#imports';
import { isHotBadgeShow, viewNewBadge } from '@core/api/oj/galaxy';

const props = defineProps<{
  isFulfillmentUser: boolean;
}>();

const route = useRoute();
const showBadge = ref(false);
const showNewBadge = ref(false);

const isContestActive = computed(() => route.path.startsWith('/oj/contest'));

const handleGalaxyClick = () => {
  if (showNewBadge.value) {
    showNewBadge.value = false;
    viewNewBadge().catch((err) => {
      console.error('[new-badge] viewNewBadge 请求失败:', err);
    });
  }
  navigateTo({ name: 'oj_galaxy' });
};

onMounted(async () => {
  if (!props.isFulfillmentUser) return;
  try {
    const res = await isHotBadgeShow();
    showBadge.value = !!res.showHot;
    showNewBadge.value = !!res.showNew;
  } catch (err) {
    showBadge.value = false;
    showNewBadge.value = false;
    console.error('[badge] isHotBadgeShow 请求失败:', err);
  }
});
</script>

<template>
  <a-dropdown
    v-if="isFulfillmentUser"
    placement="bottom"
    class="flex items-center"
  >
    <NuxtLink
      v-track:newoj_navi_contest_show
      v-track:newoj_navi_contest_click.click
      class="menu-link menu-link-text menu-link-with-badge"
      :class="{ 'router-link-active': isContestActive }"
    >
      比赛
      <span v-if="showBadge" class="hot-badge badge-tag">热门</span>
    </NuxtLink>
    <template #overlay>
      <a-menu>
        <a-menu-item>
          <NuxtLink
            :to="{ name: 'oj_contest' }"
            class="flex items-center rounded text-left"
          >
            常规赛事
          </NuxtLink>
        </a-menu-item>
        <a-menu-item>
          <NuxtLink
            v-track:oj_galaxy_topbar_entry_show
            :to="{ name: 'oj_galaxy' }"
            class="relative flex items-center rounded text-left"
            @click.prevent="handleGalaxyClick"
          >
            银河争霸赛
            <span v-if="showNewBadge" class="new-badge badge-tag">新</span>
          </NuxtLink>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <NuxtLink
    v-else
    v-track:newoj_navi_contest_show
    v-track:newoj_navi_contest_click.click
    to="/oj/contest"
    class="menu-link menu-link-text"
  >
    比赛
  </NuxtLink>
</template>

<style scoped>
.menu-link {
  padding: 4px 12px;
  line-height: 24px;
  font-size: 16px;
  @apply text-font3 relative;
}
.menu-link-text:hover {
  @apply bg-colorFillSecondary text-subtitle;
  border-radius: 4px;
}
.menu-link-text.router-link-active {
  font-weight: bold;
  @apply text-font1;
}
.menu-link-text.router-link-active::after {
  content: ' ';
  width: 70%;
  height: 3px;
  border-radius: 3px;
  @apply bg-primary absolute bottom-0 left-0 right-0 mx-auto;
}
.menu-link-with-badge {
  position: relative;
}
.badge-tag {
  position: absolute;
  right: -14px;
  height: 14px;
  line-height: 14px;
  font-size: 10px;
  text-align: center;
  border-radius: 30px;
  @apply bg-error text-white;
}
.hot-badge {
  top: -2px;
  width: 28px;
}
.new-badge {
  top: -6px;
  width: 20px;
}
</style>
